import React, { Suspense } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import ProtectedRoute from "../middleware/ProtectedRoute";
import GlobalLoader from "../components/GlobalLoader";
import ScrollToTop from "../components/ScrollToTop";
import GuestRoute from "./GuestRoute";

const LayoutWrapper = React.lazy(() =>
  import("../components/LayoutWrapper")
);

// Public pages
const UserHomePage = React.lazy(() =>
  import("../pages/user-login/Home")
);
const WorkPage = React.lazy(() =>
  import("../pages/work/page")
);
const WorkCategoryPage = React.lazy(() =>
  import("../pages/work/category/page")
);

// Admin pages
const Home = React.lazy(() =>
  import("../pages/Home")
);
const CategoryCreate = React.lazy(() =>
  import("../pages/category/create")
);
const CategoryListPage = React.lazy(() =>
  import("../pages/category/list")
);
const ProjectCreate = React.lazy(() =>
  import("../pages/project/create")
);
const ProjectListPage = React.lazy(() =>
  import("../pages/project/list")
);
const CompanyPage = React.lazy(() =>
  import("../pages/company/info")
);

const ClientCreate = React.lazy(() =>
  import("../pages/client/create")
);

const ClientListPage = React.lazy(() =>
  import("../pages/client/list")
);

const LoginPage = React.lazy(() =>
  import("../pages/login/page")
);



export default function Router() {
  return (
    <BrowserRouter>
       <ScrollToTop />
      <Suspense fallback={<GlobalLoader />}>

        <Switch>

          {/* PUBLIC ROUTES - No LayoutWrapper */}
          <Route exact path="/" component={UserHomePage} />

          <Route exact path="/work" component={WorkPage} />

          <Route
            exact
            path="/work/:slug"
            component={WorkCategoryPage}
          />

          <Route
          exact
          path="/login"
          render={() => (
            <GuestRoute>
              <LoginPage />
            </GuestRoute>
          )}
        />


          {/* ADMIN ROUTES - Protected + Layout */}
          <Route
            path="/"
            render={() => (
              <ProtectedRoute>
                <LayoutWrapper>
                  <Switch>

                    


                    <Route
                      exact
                      path="/home"
                      component={Home}
                    />

                    <Route
                      exact
                      path="/category/new"
                      component={CategoryCreate}
                    />

                     <Route
                      exact
                      path="/category/edit/:id"
                      component={CategoryCreate}
                    />

                    <Route
                      exact
                      path="/category/list"
                      component={CategoryListPage}
                    />

                    <Route
                      exact
                      path="/project/new"
                      component={ProjectCreate}
                    />

                    <Route
                      exact
                      path="/project/edit/:id"
                      component={ProjectCreate}
                    />

                    <Route
                      exact
                      path="/project/list"
                      component={ProjectListPage}
                    />

                    <Route
                      exact
                      path="/company"
                      component={CompanyPage}
                    />

                     <Route
                      exact
                      path="/client/new"
                      component={ClientCreate}
                    />

                    <Route
                      exact
                      path="/client/edit/:id"
                      component={ClientCreate}
                    />

                    <Route
                      exact
                      path="/client/list"
                      component={ClientListPage}
                    />
                  </Switch>
                </LayoutWrapper>
              </ProtectedRoute>
            )}
          />

        </Switch>

      </Suspense>
    </BrowserRouter>
  );
}